import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get users
export const getUsers = createAsyncThunk('users', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/user/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create user
export const createUser = createAsyncThunk('user-create', async (user: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/user/store', user)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get user by id
export const getUserById = createAsyncThunk('user-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`api/user/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Update user
export const updateUser = createAsyncThunk('user-update', async (user: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/user/update', user)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete user
export const deleteUser = createAsyncThunk('user/delete', async (user_id: string, thunkAPI) => {
  try {
    const res = await axios.post(`/api/user/destroy/${user_id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Update user password
export const updateUserPassword = createAsyncThunk(
  'update-password',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/user/change-password', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetLecturerUsers = createAsyncThunk('lecturer-users', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/user/lecturer-list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStduentUsers = createAsyncThunk('student-users', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/user/student-users-list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SetUserLanguage = createAsyncThunk('set-lang', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/user/set-lang/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SetCampus = createAsyncThunk('update-user-campus', async (user: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/select-campus', user)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// User Types
type UserState = {
  users: any
  user: any
  total_users: any
  total_roles: any
  total_permission: any
  errors: any
}

const initialState: UserState = {
  users: {
    data: [],
  },
  user: {},
  total_users: '',
  total_roles: '',
  total_permission: '',
  errors: '',
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.fulfilled, (state, action: PayloadAction<any>) => {
        state.users = action.payload
      })
      .addCase(createUser.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(updateUser.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(updateUserPassword.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = userSlice.actions
export default userSlice.reducer
